import { render, staticRenderFns } from "./Yunshu.vue?vue&type=template&id=08382d9f&scoped=true&"
import script from "./Yunshu.vue?vue&type=script&lang=js&"
export * from "./Yunshu.vue?vue&type=script&lang=js&"
import style0 from "./Yunshu.vue?vue&type=style&index=0&id=08382d9f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08382d9f",
  null
  
)

export default component.exports